import { __assign, __makeTemplateObject, __rest } from "tslib";
import MuiTable from '@material-ui/core/Table';
import { styled, useThemeProps } from '../../foundation';
import React, { forwardRef, useMemo } from 'react';
import { RcTableContext } from './context';
var _RcTable = forwardRef(function (props, ref) {
    var _a = useThemeProps({ props: props, name: 'RcTable' }), children = _a.children, size = _a.size, rest = __rest(_a, ["children", "size"]);
    var tableContextValue = useMemo(function () { return ({ size: size }); }, [size]);
    return (React.createElement(MuiTable, __assign({}, rest, { ref: ref }),
        React.createElement(RcTableContext.Provider, { value: tableContextValue }, children)));
});
var RcTable = styled(_RcTable)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcTable.displayName = 'RcTable';
export { RcTable };
var templateObject_1;
